export default __webpack_public_path__ + "static/media/feeling_proud.6588eb5c.svg";